import { catchError, switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, Input, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProcessoMovimentacaoService } from '@app/services/processo-movimentacao.service';
import { TipoMovimentacao } from '@app/models/processo-movimentacao';
import { UploadFile, UploadStatusNome } from '@app/components/upload-file/upload-file';
import { from, Observable, of, throwError } from 'rxjs';
import { ProcessoService } from '@app/services/processo.service';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { BlobServiceClient, BlockBlobUploadOptions, ContainerClient } from '@azure/storage-blob';

@Component({
  selector: 'app-movimentacao-anexo-form',
  templateUrl: './movimentacao-anexo-form.component.html'
})
export class MovimentacaoAnexoFormComponent implements OnInit {

  titulo: string;
  titulo2: string;
  bsModalRef: BsModalRef;
  arquivoAbaixo20MB: boolean = true;

  lstErros: string[] = [];
  tipo: string;
  processoId: number;
  movimentacaoId: number;
  tipoMovimentacao: TipoMovimentacao;
  aguardandoSolicitacao: boolean = false;
  descricaoMovimentacao: any;

  files: Array<UploadFile> = [];
  public documentos: ProcessoAnexo[] = [];
  arquivosConcluidos: Array<UploadStatusNome> = [];
  requisicoes: Observable<any>[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoMovimentacaoService: ProcessoMovimentacaoService,
    private processoService: ProcessoService,
    @Inject(ToastrService) private toastr: ToastrService,
    public modalService: BsModalService
  ) { }

  ngOnInit() {

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
      });

    this.route.params.subscribe(params => {
      this.tipo = params['tipo'];
      switch (this.tipo.toUpperCase()) {
        case 'ADMINISTRATIVA':
          this.titulo = 'Movimentação Administrativa';
          this.tipoMovimentacao = TipoMovimentacao.ADMINISTRATIVA;
          break;
        case 'EXECUCAO-PROVISORIA':
          this.titulo = 'Movimentação Execução Provisória';
          this.tipoMovimentacao = TipoMovimentacao.EXECUCAO_PROVISORIA;
          break;
        case 'JUDICIAL':
          this.titulo = 'Movimentação Judicial';
          this.tipoMovimentacao = TipoMovimentacao.JUDICIAL;
          break;
        default:
          this.tipoMovimentacao = null;
      }
    });

    this.route.params.subscribe(params => {
      this.movimentacaoId = params['movid'];
      this.titulo2 = 'Inserir anexos';

      if (!this.movimentacaoId) {
        this.router.navigate(['./processos/buscar-processos']);
      } else {
        this.processoMovimentacaoService.obterDescricaoMovimentacaoPorId(this.movimentacaoId)
          .subscribe((data) => this.descricaoMovimentacao = data);
      }
    });
  }

  verificaTamanhoFileList(){
    if (!this.arquivoAbaixo20MB){
      if (this.files.length > 1){
        for (let index = 1; index < this.files.length; index++) {
          this.files.pop();
        }
      }
    }
  }

  modificaFluxoArquivo(): void {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = `Deseja realmente mudar a opção de upload de arquivos ?
    Todos os arquivos inseridos serão deletados !`
    this.bsModalRef.content.confirmar = () => {
      this.arquivoAbaixo20MB = !this.arquivoAbaixo20MB;
      this.files = [];
    };
  }

  onSubmit() {
    if (this.arquivoAbaixo20MB){
      this.adicionarArquivosPequenos();
    }
    else{
      this.adicionarArquivosGrandes();
    }
  }

  adicionarArquivosGrandes() {
    document.getElementById('overlay').style.display = 'block';
    this.lstErros = [];
    if (this.files.length > 0) {
      if (this.files[0].File.size > 1073741824) {
        this.toastr.error(this.files[0].File.name, 'Tamanho de Arquivo superior a 1 GB');
        return;
      }

      let processoAnexo = this.AdicionarInformacoesProcessoAnexo(this.files[0]);

      if (processoAnexo.Extensao.IsNullOrEmpty()){
        this.toastr.error(this.files[0].File.name, 'Arquivo sem extensão, Altere o nome do arquivo para que ele possua uma extensão !');
        return;
      }

      this.AdicionarAnexoDiretamenteNoStorage(processoAnexo, this.files[0]).then(() => {
        history.go(-1);
        document.getElementById('overlay').style.display = 'none';
      }).catch(() => {
        this.lstErros.push("Não foi possível realizar o upload!");
        this.toastr.error('Erro ao realizar o upload do arquivo.');
        document.getElementById('overlay').style.display = 'none';
        this.aguardandoSolicitacao = false;
      });
    }


  }

  AdicionarAnexoDiretamenteNoStorage(processoAnexo: ProcessoAnexo, fileProcessoAnexo: UploadFile): Promise<void>{
      let idAnexoMovimentacao: number = 0;

      return this.processoService.movimentacaoGravarProcessoAnexoRetornandoSas(processoAnexo).pipe(
        switchMap(uploadFileSasUrl => {
          fileProcessoAnexo.progress = 0;

          idAnexoMovimentacao = Number.parseInt(uploadFileSasUrl.NomeArquivo.replace(/([A-z]+)\_(\d+)\.([A-z0-9]+)/, "$2"), 10);

          let blobService: BlobServiceClient = new BlobServiceClient(
            uploadFileSasUrl.SasUrlUpload
          );

          let containerClient: ContainerClient = blobService.getContainerClient('');

          const blobClient = containerClient.getBlockBlobClient(uploadFileSasUrl.NomeArquivo);

          fileProcessoAnexo.progress = 10;

          let optionsBlobClient: BlockBlobUploadOptions = {
            onProgress: (ev) => { fileProcessoAnexo.progress = Math.round((ev.loadedBytes / fileProcessoAnexo.File.size) * 80) + 10; },
            blobHTTPHeaders: { blobContentType: fileProcessoAnexo.File.type }
          };

          let observableUploadArquivoDiretamentoNoStorage = from(blobClient.upload(fileProcessoAnexo.File, fileProcessoAnexo.File.size, optionsBlobClient));

          return observableUploadArquivoDiretamentoNoStorage;
        }),
        switchMap(() =>
          this.processoService.verificaExistenciaArquivoMovimentacao(idAnexoMovimentacao, "proanexo").pipe(
            switchMap((arquivoExiste) => {
              if (arquivoExiste === true) {
                fileProcessoAnexo.progress = 100;
                return of(void 0);
              }
              return throwError(() => new Error('Arquivo não encontrado no storage após upload'));
            })
          )
        ),
        catchError(error => {
          if (!idAnexoMovimentacao) {
            return throwError(() => error);
          }
          return this.processoService.movimentacaoDeletarArquivo(idAnexoMovimentacao).pipe(
            catchError(() => of(void 0)),
            switchMap(() => throwError(() => error))
          );
        })
      ).toPromise();
  }

  AdicionarInformacoesProcessoAnexo(fileProcessoAnexo: UploadFile) {
    let processoAnexo = new ProcessoAnexo();
    let fileNameArray: string[] = fileProcessoAnexo.File.name.split('.');

    processoAnexo.ArquivoNome = fileProcessoAnexo.File.name;
    processoAnexo.Descricao = fileProcessoAnexo.Descricao;
    processoAnexo.Extensao = fileNameArray[fileNameArray.length - 1];


    processoAnexo.MovimentacaoId = this.movimentacaoId;
    processoAnexo.ProcessoId = this.processoId;
    return processoAnexo;
  }

  adicionarArquivosPequenos() {
    document.getElementById('overlay').style.display = 'block';
    this.aguardandoSolicitacao = true;
    this.arquivosConcluidos = [];
    this.requisicoes = [];
    this.lstErros = [];
    let contadorSucesso = 0;
    let contadorFinalizado = 0;
    const totalArquivos = this.files.length;
    if (this.files.length > 0 || this.documentos.length > 0) {
      if (this.files.length > 0) {
        for (let j = 0; j < this.files.length; j++) {
          let processoAnexo: ProcessoAnexo = new ProcessoAnexo();

          this.arquivosConcluidos.push({status: false, nomeArquivo: this.files[j].Descricao});

          processoAnexo = this.AdicionarInformacoesProcessoAnexo(this.files[j]);

          this.AdicionarAnexoDiretamenteNoStorage(processoAnexo, this.files[j]).then(() => {
            contadorSucesso++;
            this.arquivosConcluidos[j].status = true;
          }).catch(() => {
            this.lstErros.push("Não foi possível realizar o upload!");
            this.toastr.error('Erro ao realizar o upload do arquivo.');
          }).finally(() => {
            contadorFinalizado++;
            if (contadorFinalizado === totalArquivos) {
              this.aguardandoSolicitacao = false;
              document.getElementById('overlay').style.display = 'none';
              if (contadorSucesso === totalArquivos) {
                history.go(-1);
              }
            }
          });
        }
      }

      if (this.documentos.length > 0) {
        for (let j = 0; j < this.documentos.length; j++) {
          const formData: FormData = new FormData();
          formData.append('documentoId', this.documentos[j].Id.toString());
          formData.append('descricao', this.documentos[j].Descricao);

          this.arquivosConcluidos.push({status: false, nomeArquivo: this.documentos[j].Descricao});

          this.requisicoes.push(this.processoService.movimentacaoCopiarDocumento(this.processoId, this.movimentacaoId, formData));
        }
      }
    }
  }

  overlayAguarde(aparece: boolean): void {
    if(aparece) {
      document.getElementById('overlay').style.display = 'block';
    } else if(!aparece) {
      document.getElementById('overlay').style.display = 'none';
    }

  }



}
